/**
 * Returns the app name.
 */
export const useAppPublisher = (): boolean => {
  const appPublisher = import.meta.env.VITE_PUBLISHER_NAME || 'Boston Heart Diagnostics Corporation';
  return appPublisher;
};
